import { useRef, useEffect, useState, useContext } from "react";
import { Card, Button, Container } from "react-bootstrap";
import styles from "@/styles/Questions.module.scss";
import { useRouter } from "next/router";
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


const Offerings = ({
  WhyCubetFor,
  OurServices,
  setSelectedItem,
  disbaleScrollThrough,
}: any) => {
  const router = useRouter();
  const { query } = router;
  const numberOfCards = OurServices?.Collection?.length || 0;
  const scrollTargetElementRef = useRef<HTMLDivElement | null>(null);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // scroll to view
    cardRefs.current.forEach((ref, index) => {
      ref?.classList.remove('active');
      if (ref && OurServices.Collection[index].id == query?.id) {
        const addActiveClassTimer = setTimeout(() => {
          ref.classList.add('active');

          // TEMPORARILY DISABLE GSAP SCROLLTRIGGER
          if (ScrollTrigger.getAll().length > 0) {
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
          }

          ref.scrollIntoView({ behavior: 'smooth', block: "center", inline: "center" });

          // RE-ENABLE GSAP SCROLLTRIGGER AFTER SCROLL
          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 500);
        }, 100);

        return () => {
          clearTimeout(addActiveClassTimer);
        };
      }
    });
  }, [router, query.id]);


  useEffect(() => {
    if (disbaleScrollThrough) {
      ScrollTrigger.refresh()
    }
    if (window.innerWidth >= 850 && numberOfCards >= 3) {
      gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
      const section: any = scrollRef.current;
      const scrollContainer = section.querySelector(".scroll-container");

      gsap.to(scrollContainer, {
        x: () =>
          -(scrollContainer.scrollWidth - section.offsetWidth + 104) + "px",
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "center center",
          end: () => "+=" + (scrollContainer.scrollWidth - section.offsetWidth),
          scrub: disbaleScrollThrough ? 0 : 1,
          pin: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
      });
      ScrollTrigger.create({
        trigger: section,
        start: "top",
        onEnter: () => {
          gsap.to(window, {
            scrollTo: { autoKill: false },
            ease: "none",
          });
        },
      });

      return () => {
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      };
    }


  }, [router, disbaleScrollThrough])

  useEffect(() => {
    let offerings = document.getElementById("offerings");
    let caseStudy = document.getElementById("case-studies");
    let whyChoose = document.getElementById("why-chooseus");
    let head = document.getElementById("offerings-head");
    let start = document.getElementById("offering-start");

    let sections = [head, start, offerings, caseStudy, whyChoose];

    const observerOptions = {
      root: null,
      rootMargin: window.innerWidth >= 1700 ? "-50px" : "0px",
      threshold: window.innerWidth <= 375 ? 0.3 : 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      if (disbaleScrollThrough) return; // Don't override selection during manual scroll

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let id = entry.target.id;

          if (id === "offerings-head" || id === "offering-start" || id === "offerings") {
            setSelectedItem("offerings");
          }
          if (id === "case-studies") {
            setSelectedItem("case-studies");
          }
          if (id === "why-chooseus") {
            setSelectedItem("why-chooseus");
          }

          console.log(id);
        }
      });
    }, observerOptions);

    sections.forEach((section) => section && observer.observe(section));

    return () => {
      sections.forEach((section) => section && observer.unobserve(section));
    };
  }, [disbaleScrollThrough]); // Observe changes in `disbaleScrollThrough`



  return (
    <>
      <div className={styles.horizontal}>
        <Container fluid className="p-0">
          <div className="offerings-heading" id="offerings-head">
            <h4>{WhyCubetFor?.Title}</h4>
            <p>{WhyCubetFor?.Description}</p>
          </div>
          <div id="gsapstart"></div>
          <div
            ref={scrollRef}
            className="horizontal-scroll-section background-scroll"
            id="offering-start"
          >
            <div className="background-black-off" id="offerings" >
              <h2 className="p-104">{OurServices?.Title}</h2>

              <div
                className="scroll-container d-flex p-104"
                ref={scrollTargetElementRef}
              >
                {OurServices?.Collection?.map((solution: any, index: any) => (
                  <Card key={solution.id} ref={(el: any) => (cardRefs.current[index] = el)} className={`scroll-card`}>
                    <div className="number-data">
                      {index + 1 < 10 ? `0${index + 1}` : index + 1}
                    </div>
                    <Card.Body
                      className="p-0"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        gap: "20px",
                      }}
                    >
                      <div>
                        <Card.Title>{solution?.Title}</Card.Title>
                        <Card.Text>
                          {solution?.ShortDescription.length > 500
                            ? `${solution?.ShortDescription.substring(
                              0,
                              500
                            )}...`
                            : solution?.ShortDescription}
                        </Card.Text>
                      </div>
                      {solution.LinkUrl ? <div
                        className="arrow"
                        onClick={() => router.push(solution.LinkUrl)}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.16699 10H15.8337"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M10 4.16797L15.8333 10.0013L10 15.8346"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div> : ''}
                    </Card.Body>
                  </Card>
                ))}
              </div>

              <div className="gap-3 d-flex justify-content-start bottom-know-more">
                <span>
                  Not sure which service is right for you? Contact us to make
                  the best decision for your project with expert guidance.
                </span>
                <Button
                  className="animated-button text-button"
                  onClick={() => router.push("/contact-us/")}
                >
                  Talk to us now
                </Button>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Offerings;
